<!--  -->
<template>
    <div class='wrapper' ref="middle3_right">
        <div class="tabTitle box box_between">
            <div class="title1">企业问题排名</div>
            <div class="box tab">
                <div class="tabitem" :class="{'active':tabSelect==0}" @click="clickTab(0)">收集问题</div> 
                <div class="tabitem" :class="{'active':tabSelect==1}" @click="clickTab(1)">解决问题</div> 
            </div>
        </div>
        <div class="tr box">
            <div class="td0">排名</div>
            <div class="td1">企业</div>
            <div class="td3 box_f1">收集问题</div>
            <div class="td3 box_f1">解决问题</div>
            
        </div>
        <scroll  :style="{'height':height}">
            <div class="tr_item box_f1 box" v-for="(item,index) in topData" :key="index">
                <div class="td0">{{index+1}}</div>
                <div class="td1 slh">{{item.companyName}}</div>
                <div class="td3 box_f1">{{item.collectCount}}件</div>
                <div class="td3 box_f1">{{item.resolveCount}}件</div>
                
            </div>
        </scroll>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import scroll from './scroll'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {scroll},
    data() {
    //这里存放数据
        return {
            topData:[],
            height:'100%',
            tabSelect:0,
            orderField:'collectCount'
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.companyRank,{
                pageNum:1,
                pageSize:10,
                orderField:this.orderField,
                orderSeq:'desc'
            }).then(res=>{
                this.topData = res.rows
            })
        },
        clickTab(index){
            this.tabSelect = index
            if(index==0){
                this.orderField = 'collectCount'
            }else{
                this.orderField = 'resolveCount'
            }
            this.getData()
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
            this.height = this.$refs.middle3_right.offsetHeight-115 + 'px'
            this.getData()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
}
.tabTitle{
    align-items: center;
    padding:20px 30px 10px 40px;
    .title1{
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
    }
    .tab{
        font-size: 14px;
        font-weight: bold;
        color: #0088C8;
        cursor: pointer;
        height:14px;
        line-height: 14px;
    }
    .tabitem:first-child{
        padding-right:15px;
        border-right:1px solid #0088C8
    }
    .tabitem:last-child{
        padding-left:15px;
    }
    .active{
        color:#89D9FF
    }
}


.tr{
    color:#0EFCFF;
    margin:10px;
    height: 38px;
    line-height:38px;
    background: linear-gradient(90deg, rgba(21, 144, 245, 0) 0%, #0067BC 48%, rgba(21, 144, 245, 0) 100%);
}
.td0{
    width:60px;
    text-align: center;
    color:#0EFCFF;
}
.td1{
    width:180px;
    text-align: left;
    color:#0EFCFF;
}
.td2{
    color:#0EFCFF;
    text-align: center;
    width:100px;
}
.td3{
    
    text-align: center;
}
.td4{
    width:60px;
}
.tr_item{
    line-height: 35px;
    margin:0 10px;
    .td0{
        margin:8px 19px;
        width: 22px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #FFF550;
        background: rgba(255, 255, 255, 0);
        box-shadow: 0px 1px 2px 0px rgba(8, 1, 3, 0.35), 0px 3px 7px 0px rgba(149, 204, 255, 0.82);
        border-radius: 6px;
    }
    .td3{
        font-size: 14px;
        font-style: italic;
        font-weight:bold;
        background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .td1:active{
        height: 35px;
        background: linear-gradient(90deg, rgba(0, 252, 255, 0.4) 0%, rgba(0, 25, 36, 0.2) 100%);
    }
}

</style>